<template>
    <header class="rtb-form-header">
        <div>
            <h1 class="rtb-form-header__title">{{ title }}</h1>
            <p v-if="help" class="rtb-form-header__help">{{ help }}</p>
        </div>
        <RtbStatusBadge
            v-if="displayStatus"
            :status="displayStatus"
            :label="displayStatusLabel"
        />
    </header>

    <p v-if="isReadOnly" class="rtb-form-banner rtb-form-banner--muted" role="status">
        Режим только просмотра — изменения недоступны
    </p>
    <p v-else-if="isDraft" class="rtb-form-banner rtb-form-banner--info" role="status">
        Черновик: заполните обязательные поля и нажмите «Сохранить», чтобы отправить кампанию на модерацию.
    </p>
    <p v-else-if="statusHint" class="rtb-form-banner" :class="`rtb-form-banner--${tone}`" role="status">
        {{ statusHint }}
    </p>
    <p v-if="willRemoderate" class="rtb-form-banner rtb-form-banner--warning" role="status">
        Эти изменения отправят кампанию на повторную модерацию. Показы остановятся, пока модератор не одобрит её снова.
    </p>
</template>

<script setup>
import { computed } from 'vue';
import RtbStatusBadge from '../list/RtbStatusBadge.vue';
import { RTB_STATUS_TONE } from '../../../../constants/rtbCampaigns';

const props = defineProps({
    title: { type: String, required: true },
    help: { type: String, default: '' },
    isReadOnly: { type: Boolean, default: false },
    isDraft: { type: Boolean, default: false },
    displayStatus: { type: String, default: '' },
    displayStatusLabel: { type: String, default: '' },
    statusHint: { type: String, default: '' },
    willRemoderate: { type: Boolean, default: false },
});

const tone = computed(() => RTB_STATUS_TONE[props.displayStatus] || 'muted');
</script>

<style scoped lang="scss">
@use '../../../../../scss/pages/admin/admin-tokens' as *;

.rtb-form-header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: $spacing-lg;
}

.rtb-form-header__title {
    margin: 0;
    font-size: $font-size-3xl;
    font-weight: 700;
    color: $admin-text-primary;
}

.rtb-form-header__help {
    margin: $spacing-xs 0 0;
    font-size: $font-size-base;
    color: $admin-text-muted;
    line-height: 1.5;
}

.rtb-form-banner {
    margin: 0;
    padding: $spacing-md $spacing-lg;
    border-radius: $radius-md;
    font-size: $font-size-sm;
    font-weight: 500;

    &--muted { background: $admin-bg-hover; color: $admin-text-secondary; }
    &--info { background: #eef2ff; color: #3730a3; }
    &--warning { background: $admin-warning-bg; color: $admin-warning-color; }
    &--success { background: $admin-success-bg; color: $admin-success-color; }
    &--danger { background: $admin-danger-bg; color: $admin-danger-color; }
}
</style>
